import WellnubService from './WellnubService';

import { BASE_URL } from '../constants';

class ContactService extends WellnubService {
  post = payload => this.axios.post(`${BASE_URL}/v1/contact`, payload);
}

export default ContactService;